import React from 'react';

const BookPage = React.forwardRef(({ children, className = '', pageNumber, hard }, ref) => {
  return (
    <div
      ref={ref}
      className={`book-page ${className}`}
      data-density={hard ? 'hard' : 'soft'}
    >
      <div className="book-page-inner">
        {children}
        {pageNumber !== undefined && (
          <div className="book-page-number">{pageNumber}</div>
        )}
      </div>
    </div>
  );
});

BookPage.displayName = 'BookPage';
export default BookPage;
